import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import classNames from 'classnames';

import { FormFieldContext } from '../form-field/form-field.context';
import { ReactComponent as FileIcCloudUpload24px } from '../../../assets/icons/file/ic_cloud_upload_24px.svg';

let nextUniqueId;
nextUniqueId = 0;

const defaultIcons = {
  upload: <FileIcCloudUpload24px />
};

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [label]
 * @prop {{upload: React.ReactNode}} [icons]
 * @prop {string} [id]
 * @prop {() => void} [onDrop]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifFileUploader = (props) => {
  const {
    children,
    className = '',
    disabled = false,
    label = '',
    icons: userIcons = {},
    id = '',
    onDrop: onDropCallback = null,
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const context = useContext(FormFieldContext);

  useState(() => {
    id ? context.setId(id) : context.setId(`motif-file-uploader-${nextUniqueId++}`);
  });

  const classes = classNames({
    'motif-file-uploader': true,
    'motif-disabled': disabled,
    'motif-invalid': context.invalid,
    [className]: true
  });
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({ ...other, disabled });

  useEffect(() => {
    if (onDropCallback) {
      const preMerged = [...acceptedFiles, ...fileRejections];
      const merged = preMerged.map((fileItem) => {
        if (fileItem.errors) {
          const { file, errors } = fileItem;
          file.error = errors[0].message;

          return file;
        }

        return fileItem;
      });
      if (merged.length) {
        onDropCallback(merged);
      }
    }
  }, [acceptedFiles, fileRejections]);

  return (
    <div className={classes} data-motif-file-uploader data-testid="file-uploader-wrapper">
      <button className="dropzone-container" {...getRootProps()}>
        <input id={context.id} {...getInputProps()} aria-labelledby={`${context.id}-label`} />
        <span className="motif-file-uploader-label" id={`${context.id}-label`}>
          <span className="motif-icon">{icons.upload}</span>

          <span className="motif-file-uploader-label-text">{label}</span>
        </span>
      </button>
      {children}
    </div>
  );
};

MotifFileUploader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icons: PropTypes.shape({
    upload: PropTypes.node
  }),
  id: PropTypes.string,
  onDrop: PropTypes.func,
  label: PropTypes.string
};

export { MotifFileUploader };
